import { useDataChange } from 'Simple/Data.js'
export function useOnClose(props) {
  let change = useDataChange({
    context: 'edit_email',
    viewPath: props.viewPath,
  })
  return function onClose() {
    change(next => {
      next.email = null
      next.id = null
    })
  }
}
